/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import NetworkSettingsDirective from './network-settings.directive';

export default angular.module('tektelic.networkSettings', [])
    .directive('tkNetworkSettings', NetworkSettingsDirective)
    .name;



// WEBPACK FOOTER //
// ./src/app/network-settings/index.js